import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const GetFormatDate = (date: string) => {
  let datePart = date;

  // if (date.includes('T')) {
  //   const [d] = date.split('T');
  //   datePart = d;
  // }
  const dateObj = new Date(`${datePart}`);
  return dateObj.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
};

export const formatDateTime = (dateString: string, format?: string) => {
  if (!dateString) return '';

  const dateObj = new Date(dateString);

  if (isNaN(dateObj.getTime())) return '';

  // If format is specified, use date-fns style formatting
  if (format) {
    const pad = (num: number) => num.toString().padStart(2, '0');

    const formatMap: { [key: string]: string } = {
      'yyyy': dateObj.getFullYear().toString(),
      'MM': pad(dateObj.getMonth() + 1),
      'dd': pad(dateObj.getDate()),
      'HH': pad(dateObj.getHours()),
      'mm': pad(dateObj.getMinutes()),
      'ss': pad(dateObj.getSeconds()),
    };

    let result = format;
    Object.keys(formatMap).forEach(key => {
      result = result.replace(new RegExp(key, 'g'), formatMap[key]);
    });

    return result;
  }

  // Default format
  return dateObj.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

export const formatDuration = (duration: number) => {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;

  if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`;
  }
  if (minutes > 0) {
    return `${minutes}m ${seconds}s`;
  }
  return `${seconds}s`;
};

export const getMediaDuration = (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    let media: HTMLMediaElement;

    // Determine whether audio or video
    if (file.type.startsWith("audio")) {
      media = document.createElement("audio");
    } else if (file.type.startsWith("video")) {
      media = document.createElement("video");
    } else {
      reject(new Error("File is not audio or video"));
      return;
    }

    media.preload = "metadata";
    media.src = url;

    media.onloadedmetadata = () => {
      URL.revokeObjectURL(url);
      resolve(media.duration); // Duration in seconds
    };

    media.onerror = () => {
      reject(new Error("Failed to load media metadata"));
    };
  });
};

/**
 * Resolves content URL for images and videos
 * Handles both direct URLs and JSON-encoded file objects
 */
export const resolveContentUrl = (content: string): string => {
  if (!content) return '';

  try {
    const parsed = typeof content === 'string' ? JSON.parse(content) : content;
    if (parsed && typeof parsed === 'object') {
      const fileName = (parsed.fileName || parsed.FileName || parsed.file?.fileName || parsed.name) as string | undefined;
      if (fileName) {
        return `${import.meta.env.VITE_API_DOMAIN}/files?fileName=${encodeURIComponent(fileName)}`;
      }
    }
  } catch (err) {
    // Not a JSON string, treat as regular string
  }
  return content.startsWith('http') ? content : `${import.meta.env.VITE_API_DOMAIN}/files?fileName=${encodeURIComponent(content)}`;
};